import React from 'react'
import { observer } from 'mobx-react'
import ResponsesCard from '../ResponsesCard'
import JobViewModel from '../JobViewModel'
import InfoLinesCard from '../InfoLinesCard'
import EventsCard from '../EventsCard'
import DocumentsCard from '../DocumentsCard'
import styles from './DetailsView.sass'
import PromptsCard from '../PromptsCard'
import AmendmentsCard from '../AmendmentsCard'
import MilestonesCard from '../MilestonesCard'
import CapturedInformationCard from '../CapturedInformationCard'
import JobScopeChangeRequestsCard from '../JobScopeChangeRequestsCard'
import { useDocumentTitle } from '../../../../../hooks/document-title'

interface Props {
  vm: JobViewModel
}

export default observer(function DetailsView({ vm }: Props) {
  return vm.showDraftView ? <DraftView vm={vm} /> : <JobView vm={vm} />
})

const DraftView = observer(function DraftView({ vm }: Props) {
  return (
    <div className={styles.root}>
      {(vm.useJobCreationDialog ||
        vm.detailsVM.canViewCapturedInfoCardAsAdmin ||
        vm.detailsVM.useEditDraftJobForFirmAdmin) && (
        <CapturedInformationCard vm={vm} />
      )}

      {vm.canViewDocs && <DocumentsCard vm={vm} />}
      {vm.canViewAmendments && <AmendmentsCard vm={vm} />}
    </div>
  )
})

const JobView = observer(function JobView({ vm }: Props) {
  useDocumentTitle(`${vm.job.workspace.name} | ${vm.job.displayName}`)

  return (
    <div className={styles.root}>
      {vm.detailsVM.canViewCapturedInfoCardAsAdmin ? (
        <CapturedInformationCard vm={vm} />
      ) : (
        <ResponsesCard vm={vm} />
      )}

      {vm.canViewDocs && <DocumentsCard vm={vm} />}

      {vm.job.infoLines.length > 0 && <InfoLinesCard vm={vm} />}

      {(vm.canCreatePrompt || vm.detailsVM.promptsList.prompts.length > 0) && (
        <PromptsCard vm={vm} />
      )}

      {vm.canViewAmendments && <AmendmentsCard vm={vm} />}

      {vm.canViewScopeChangeRequests &&
        vm.scopeChangeRequests.length > 0 &&
        !vm.showDraftView && <JobScopeChangeRequestsCard vm={vm} />}

      <EventsCard vm={vm} />

      {vm.milestonesVM.milestones.length > 0 &&
        !vm.showDraftView &&
        !vm.isProgressionFlowEnabled && <MilestonesCard vm={vm} />}
    </div>
  )
})
